import React from 'react';
import { Navigate } from 'react-router-dom';

function ProtectedRoute({ element: Component, isLoggedIn, loading, ...props }) {
  if (loading) return null;
  return isLoggedIn ? <Component {...props} /> : <Navigate to="/signin" />;
}

export default ProtectedRoute;
